module.exports = __webpack_public_path__ + "static/media/sho_default76259531aa8fe618f59300a64383a0cb.webp";